import { createConsumer } from '@rails/actioncable'

const cableEnabled = document.querySelector('meta[name="landport-cable-enabled"]')?.content === 'true'

export default cableEnabled ? createConsumer() : { subscriptions: { create: () => null } }
